import { useFormContext } from 'react-hook-form';

import type { RecruitingFormSchema } from '../schemas';

export const useRecruitingFormContext = () => {
  const context = useFormContext<RecruitingFormSchema>();

  return context;
};
